import React from 'react';
import { avatarSource } from '#config';
import classNames from 'classnames';
import s from '#components/common/avatar/avatar.module.scss';

type Props = {
  avatarAssetId?: number;
  extraClass?: string;
};

const Avatar = ({ avatarAssetId, extraClass }: Props) => {
  const blockClass = classNames(s.host, extraClass);
  const avatarImage = avatarSource(avatarAssetId, '256w');
  return (
    <span className={`${blockClass} tw-mx-auto`} data-host="avatar">
      <img className={s.inner} alt="" src={avatarImage} />
    </span>
  );
};

export default Avatar;
